export const OutletDetailsURLFlag = 'details'
